(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    function hidePriceForCardPickers() {
      document.querySelectorAll('variant-picker[data-variant-style="cards"]').forEach(function (picker) {
        var sibling = picker.previousElementSibling;
        while (sibling) {
          if (sibling.tagName.toLowerCase() === 'product-price') {
            sibling.classList.add('variant-picker--cards-hide-price');
            break;
          }
          sibling = sibling.previousElementSibling;
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hidePriceForCardPickers);
    } else {
      hidePriceForCardPickers();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
